export default __webpack_public_path__ + "static/media/PowerGrotesk-UltraLight.6508fb42.otf";